(function(){'use strict';function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct.bind();
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }
  return _construct.apply(null, arguments);
}
function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;
  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;
    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);
      _cache.set(Class, Wrapper);
    }
    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }
    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };
  return _wrapNativeSuper(Class);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}var ACTIVE_CLASS="is-active",ScrollingMedia=function(e){_inherits(o,e);var t=_createSuper(o);function o(){return _classCallCheck(this,o),t.apply(this,arguments)}return _createClass(o,[{key:"connectedCallback",value:function(){var e=this;"loading"===document.readyState?document.addEventListener("DOMContentLoaded",(function(){return e._init()}),{once:!0}):this._init();}},{key:"_init",value:function(){var e=this;this._desktopStages=Array.from(this.querySelectorAll(".scrolling-media__desktop-stage")),this._screens=Array.from(this.querySelectorAll(".scrolling-media__desktop-media-screen")),this._graphs=Array.from(this.querySelectorAll(".scrolling-media__desktop-media-graph")),this.classList.add("is-ready"),this._setupMobileHeights(),this._setupMobileAnimation(),this._setupDesktop(),window.Shopify&&window.Shopify.designMode&&this.addEventListener("shopify:block:select",(function(t){return e._onBlockSelect(t)}));}},{key:"disconnectedCallback",value:function(){var e,t;null===(e=this._desktopObserver)||void 0===e||e.disconnect(),null===(t=this._mobileResizeObserver)||void 0===t||t.disconnect(),this._onMobileScroll&&window.removeEventListener("scroll",this._onMobileScroll);}},{key:"_setupMobileHeights",value:function(){var e=this,t=Array.from(this.querySelectorAll(".scrolling-media__mobile-stage"));if(t.length){var o=function(){var o;!function(){var t=0;if(document.querySelectorAll(".shopify-section--announcement-bar, .shopify-section--header, .shopify-section-group-header-group").forEach((function(e){var o=getComputedStyle(e);if("sticky"===o.position||"fixed"===o.position){var i=Math.max(0,e.getBoundingClientRect().bottom);i>t&&(t=i);}})),t<=0){var o=getComputedStyle(document.documentElement),i=function(e){var t=o.getPropertyValue(e).trim(),i=parseFloat(t);return isNaN(i)?0:i},r=i("--header-is-sticky"),s=i("--header-is-visible"),n=i("--header-height"),l=i("--announcement-bar-is-sticky"),a=i("--announcement-bar-height");t=(r?(s||1)*n:0)+(l?a:0);}e.style.setProperty("--sm-sticky-header","".concat(Math.round(t),"px"));}(),o=t.map((function(e){var t=e.querySelector(".scrolling-media__mobile-content");return t?t.scrollHeight:0})),t.forEach((function(e,t){e.style.setProperty("--sm-content-h","".concat(o[t],"px"));var i=t>0?o[t-1]:0;e.style.setProperty("--sm-prev-content-h","".concat(i,"px"));}));};o(),this._measureMobile=o;var i=function(){o(),e._updateMobileProgress&&e._updateMobileProgress();};if("ResizeObserver"in window)this._mobileResizeObserver=new ResizeObserver(i),t.forEach((function(t){var o=t.querySelector(".scrolling-media__mobile-content");o&&e._mobileResizeObserver.observe(o);})),document.querySelectorAll(".shopify-section--announcement-bar, .shopify-section--header, .shopify-section-group-header-group").forEach((function(t){return e._mobileResizeObserver.observe(t)}));else window.addEventListener("resize",i,{passive:!0});}}},{key:"_setupMobileAnimation",value:function(){var e=this,t=Array.from(this.querySelectorAll(".scrolling-media__mobile-stage"));if(t.length){var o=function(){var o,i,r=(o=getComputedStyle(e).getPropertyValue("--sm-sticky-header").trim(),i=parseFloat(o),isNaN(i)?0:i),s=t.length-1;t.forEach((function(e,t){var o=e.querySelector(".scrolling-media__mobile-content-wrapper"),i=e.querySelector(".scrolling-media__mobile-content");if(o&&i){var n=o.offsetHeight;if(!(n<=0)){var l=0,a=0;if(t!==s){var c=e.getBoundingClientRect(),u=c.top+o.offsetTop;if(u<r){var d=c.bottom-n;(l=Math.min(r,d)-u)<0&&(l=0),(a=1-(c.bottom-r-n)/n)<0?a=0:a>1&&(a=1);}}var p=1-a,h=1-.6*a;o.style.setProperty("--sm-pin-y","".concat(l,"px")),i.style.setProperty("--sm-progress-opacity","".concat(p)),i.style.setProperty("--sm-progress-scale","".concat(h));}}}));};this._updateMobileProgress=o,this._onMobileScroll=function(){e._scrollRafId||(e._scrollRafId=requestAnimationFrame((function(){e._scrollRafId=null,e._measureMobile&&e._measureMobile(),o();})));},o(),window.addEventListener("scroll",this._onMobileScroll,{passive:!0});}}},{key:"_setupDesktop",value:function(){var e=this;this._desktopStages.length&&"IntersectionObserver"in window&&(this._desktopObserver=new IntersectionObserver((function(t){t.forEach((function(t){t.isIntersecting&&e._setActiveIndex(t.target.dataset.index);}));}),{rootMargin:"-45% 0px -45% 0px",threshold:0}),this._desktopStages.forEach((function(t){return e._desktopObserver.observe(t)})));}},{key:"_setActiveIndex",value:function(e){null!=e&&(this._screens.forEach((function(t){t.classList.toggle(ACTIVE_CLASS,t.dataset.index===e);})),this._graphs.forEach((function(t){t.classList.toggle(ACTIVE_CLASS,t.dataset.index===e);})));}},{key:"_onBlockSelect",value:function(e){var t=e.target.closest(".scrolling-media__desktop-stage");if(t)return this._setActiveIndex(t.dataset.index),void t.scrollIntoView({behavior:"smooth",block:"center"});var o=e.target.closest(".scrolling-media__mobile-stage");o&&o.scrollIntoView({behavior:"smooth",block:"start"});}}]),o}(_wrapNativeSuper(HTMLElement));window.customElements.get("scrolling-media")||window.customElements.define("scrolling-media",ScrollingMedia);})();